import { DSInput } from "@components/design-system/molecules";
import { DSModal } from "@components/design-system/organisms";

export function CopyTemplateModal({
  shouldShow,
  hideModal,
  confirmAction,
  templateName,
  customName,
  onNameChange,
}) {
  return (
    <DSModal
      isOpen={shouldShow}
      onClose={hideModal}
      title={"Copy this template?"}
      actions={[
        { label: "Cancel", variant: "cancel", onClick: hideModal },
        {
          label: "Yes, copy template",
          variant: "primary",
          onClick: confirmAction,
          dataTestId: "confirm-button",
        },
      ]}
      dataTestId="copy-template-modal"
    >
      <label htmlFor="template-name" className="block mb-sm">
        <p className="font-medium">Name your copy of the template</p>
      </label>
      <div className="mb-sm">
        <DSInput
          id="template-name"
          type="text"
          value={customName}
          onChange={(e) => onNameChange(e.target.value)}
          placeholder={`Copy of ${templateName}`}
          dataTestId="copy-template-name-input"
        />
      </div>
      <p className="text-sm text-secondary">
        You will be making a copy of <strong>{templateName}</strong>.
        Any edits you make will only update your copy and will not
        affect the original template.
      </p>
    </DSModal>
  );
}
